import React, { ComponentType, ReactNode } from "react";
import getExperimentsContext from "../react/getExperimentsContext";
import { Datafile, User } from "../types";
import OptimizelyManager from "../core/OptimizelyManager";
import createOptimizelyClient from "../core/createOptimizelyClient";

type ExperimentsProviderArgs = {
  datafile: Datafile | undefined;
  user: User;
  queryParams: URLSearchParams;
  isFeatureExperimentation: boolean;
};

const createExperimentsProvider = ({
  datafile,
  user,
  queryParams,
  isFeatureExperimentation = false,
}: ExperimentsProviderArgs): ComponentType<{ children?: ReactNode }> => {
  const ExperimentsContext = getExperimentsContext();

  const ExperimentsProvider: ComponentType<{ children?: ReactNode }> = ({
    children,
  }) => {
    const optimizelyClient = createOptimizelyClient(datafile);

    const optimizelyManager = new OptimizelyManager(
      optimizelyClient,
      user,
      queryParams,
      isFeatureExperimentation,
    );
    return (
      <ExperimentsContext.Provider value={optimizelyManager}>
        {children}
      </ExperimentsContext.Provider>
    );
  };

  return ExperimentsProvider;
};

export default createExperimentsProvider;
